import React, { useState } from "react";
import CustomCsPcInput from "../../components/dms_common/CustomCsPcInput";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import Checkbox from "@mui/material/Checkbox";
import { DeliveryInvoiceBatchDetails } from "../../types/types";
import { getUomLabel } from "../../components/dms_common/DmsUtils";
import { PrimaryReturnBatchDetails } from "./PrimaryReturnEdit";
import MultiQtyCell from "../../components/dms_common/MultiQtyCell";
import RenderSvg from "../../components/renderSvg/RenderSvg";
import PrimaryReturnQtyCell from "./PrimaryReturnQtyCell";


const PrimaryReturnBatchItem = ({
  batch,
  editBatchId,
  isSelected,
  onSelect,
  isUpdated,
  allowedReturnQtyTypes
}: {
  batch: PrimaryReturnBatchDetails;
  editBatchId?: (batchId: string)=>void;
  isSelected: boolean;
  onSelect: () => void;
  isUpdated?: boolean
  otherUnitName?: string;
  allowedReturnQtyTypes?: string[];
}) => {
  
  return (
    <div
      className={`batchContainer-delivery ${(isSelected || isUpdated) && "batch-selected-delivery"}`}
      onClick={onSelect}
    >
      <span
        className={`${(isSelected || isUpdated) && "batch-selected-delivery-text"}`}
        style={{ display: "flex", alignItems: "center", gap: "6px" }}
      >
        {batch?.batchId}{" "}
      </span>
      <div
        className="cs-pc-and-checkbox"
        style={{ display: "flex", flexDirection: "column", gap: "2px" }}
      >
        <div className="batch-input-container">
          {allowedReturnQtyTypes &&
            allowedReturnQtyTypes.length > 0 &&
            allowedReturnQtyTypes.includes("ACCEPTED") && (
              <PrimaryReturnQtyCell
                csQty={batch.acceptableCaseQty ?? 0}
                pcQty={batch.acceptablePieceQty ?? 0}
                otherQty={batch.acceptableOtherQty ?? 0}
                otherUnitName={batch.otherUnitName}
                customStyles={{
                  boxStyle: {
                    border: "1px solid #6fe2c2",
                    backgroundColor: "#F4FFFC",
                  },
                }}
              />
            )}
          {allowedReturnQtyTypes &&
            allowedReturnQtyTypes.length > 0 &&
            allowedReturnQtyTypes.includes("REJECTED") && (
              <div
                style={{ display: "flex", flexDirection: "column", gap: "4px" }}
              >
                <PrimaryReturnQtyCell
                  csQty={batch.rejectableCaseQty ?? 0}
                  pcQty={batch.rejectablePieceQty ?? 0}
                  otherQty={batch.rejectableOtherQty ?? 0}
                  customStyles={{
                    boxStyle: {
                      border: "1px solid #FF8A8A",
                      backgroundColor: "#FFF4F4",
                    },
                  }}
                  otherUnitName={batch.otherUnitName}
                />
              </div>
            )}
          <input
            className="batchListItem-radio-button"
            type="radio"
            id="selected"
            checked={isSelected}
          />
        </div>
          <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
            <RenderSvg
              name="disclaimerIcon"
              customStyles={{ color: "#DD4646", width: "9px" }}
            />{" "}
            <span
              style={{
                fontStyle: "italic",
                fontSize: "11px",
                color: "#DD4646",
                fontWeight: 500,
              }}
            >
              Reason: {batch.rejectionReason ? batch.rejectionReason : "-"}
            </span>
          </div>
      </div>
    </div>
  );
};

export default PrimaryReturnBatchItem;
